import { TypedEventEmitter } from "./typedEventEmitter";

export const ChatEventName = {
  MyMessagesMarkedAsRead: "MyMessagesMarkedAsRead",
} as const;
export type ChatEventName = (typeof ChatEventName)[keyof typeof ChatEventName];

export type ChatEventsMap = {
  // list of supported events
  [ChatEventName.MyMessagesMarkedAsRead]: { chatId: string; messageIds: string[] };
};

/** Common tenant-to-tenant events. */
class ChatEventEmitter extends TypedEventEmitter<ChatEventsMap> {}

export const chatEventEmitter = new ChatEventEmitter();
